import React from 'react';
import {useHistory} from "react-router";
import {BarChart} from "components/charts/BarChart";
import { BI, registerTestObject } from 'utils/testUtils';
import color from "../../utils/color";
import { logAndRedirectToErrorPage } from 'components/ErrorComponent';
import { useSelector } from "react-redux";
import { createLoadingSelector } from "../../state/selectors/loadingSelector";

const CollegeBi = ({ selectedStates, searchWarning}) => {
    const history = useHistory()
    const stats = useSelector(state => state.home.topColleges);
    const loadingSelector = createLoadingSelector(['HOME_DATA_TOP_COLLEGES']);
    const loading = useSelector(state => loadingSelector(state));
    const chartRef = registerTestObject(BI.HOME_COLLEGES_CHART);
    const triggerSearch = legendItem => {
        try {
            let queryString = `al=${legendItem.text}`
            if (selectedStates && selectedStates.length > 0) {
                queryString = queryString.concat("&cs=" + selectedStates.join("|"))
            }
            searchWarning(queryString);
        } catch (error) { logAndRedirectToErrorPage(error, history); }
    }
    return (
        <div>
            {loading && <span wk-icon="spinner" className="wk-spin" style={{ "verticalAlign": "middle" }}/>}
            {!loading && <BarChart
                label="Top Colleges"
                data={stats.map(item => item.data)}
                labels={stats.map(item => item.label)}
                ref={chartRef}
                legendCallBack={(event, legendItem) => triggerSearch(legendItem)}
                backgroundColors={[...color(stats.length)]}/>}
        </div>
    );
};
export default CollegeBi;
